var _ICON_SIZES;

import { css } from 'styled-components';
import { AvatarSize } from './Avatar.decl';
export var makeAvatarSize = function makeAvatarSize(_ref) {
  var size = _ref.size,
      theme = _ref.theme;
  return theme.avatar.sizes[size];
};
export var ICON_SIZES = (_ICON_SIZES = {}, _ICON_SIZES[AvatarSize.X_SMALL] = '8px', _ICON_SIZES[AvatarSize.SMALL] = '16px', _ICON_SIZES[AvatarSize.MEDIUM] = '24px', _ICON_SIZES[AvatarSize.LARGE] = '40px', _ICON_SIZES[AvatarSize.X_LARGE] = '48px', _ICON_SIZES);
export var makeAvatarIconSize = function makeAvatarIconSize(_ref2) {
  var size = _ref2.size,
      borderless = _ref2.borderless,
      hasImage = _ref2.hasImage,
      clickable = _ref2.clickable,
      theme = _ref2.theme;
  var noBorder = hasImage || borderless;

  if (noBorder) {
    var _theme$avatar$sizes$s = theme.avatar.sizes[size],
        width = _theme$avatar$sizes$s.width,
        height = _theme$avatar$sizes$s.height;
    return css(["svg{width:", ";height:", ";}", ""], width, height, clickable && "\n        &:hover,\n        &:focus {\n          svg {\n            width: calc(" + width + " - 2px);\n            height: calc(" + height + " - 2px);\n          }\n        }\n\n        &:active {\n          svg {\n            width: calc(" + width + " - 4px);\n            height: calc(" + height + " - 4px);\n          }\n        }\n      ");
  }

  var iconSize = ICON_SIZES[size];
  return {
    svg: {
      width: iconSize,
      height: iconSize
    }
  };
};
export var makeAvatarColor = function makeAvatarColor(_ref3) {
  var bg = _ref3.bg,
      backgroundColor = _ref3.backgroundColor,
      color = _ref3.color,
      variant = _ref3.variant,
      disabled = _ref3.disabled,
      hasImage = _ref3.hasImage,
      borderless = _ref3.borderless,
      clickable = _ref3.clickable,
      theme = _ref3.theme;
  var hasCustomColor = !!(bg || backgroundColor || color);

  if (!!variant || hasCustomColor) {
    return css(["opacity:", ";"], disabled ? '65%' : '100%');
  }

  var noBorder = hasImage || borderless;

  if (disabled) {
    return css(["background-color:", ";color:", ";", ";svg{fill:", ";}"], theme.colors.grey.base, theme.colors.grey.base, noBorder && "opacity: 0.5;", theme.colors.grey.base);
  }

  return css(["", " color:", ";svg{fill:", ";}", ""], !noBorder && "background-color: " + theme.colors.grey.dark + ";", theme.colors.grey.dark, theme.colors.grey.dark, clickable && "\n      cursor: pointer;\n\n      &:hover,\n      &:focus {\n        background-color: " + theme.colors.base.black + ";\n        color: " + theme.colors.grey.darker + ";\n\n        svg {\n          fill: " + theme.colors.grey.darker + ";\n        }\n      }\n\n      &:active:after {\n        top: 2px;\n        left: 2px;\n        right: 2px;\n        bottom: 2px;\n      }\n\n      &:active {\n        background-color: " + theme.colors.base.black + ";\n        color: " + theme.colors.grey.dark + ";\n        svg {\n          fill: " + theme.colors.grey.dark + ";\n        }\n      }\n    ");
}; // Props that should not be forwarded to the HTML DOM elements

export var shouldForwardProp = function shouldForwardProp(prop) {
  return !['variant', 'mode', 'size', 'disabled', 'bg', 'color', 'borderless', 'clickable', 'hasImage'].includes(prop);
};